import api from '@/services/api'

export const getUserFromAPI = async (userID) => {
    try {
        return api.get(`/users/${userID}/profile`, {
            params: {
                with: 'manager',
            },
        })
    } catch (e) {
        console.log(e)
    }
}

export const getTargets = async (id, periods, route) => {
    try {
        const response = await api.get(`users/${id}/profile/${route}`, {
            params: {
                periods,
            },
        })
        return response.data.data
    } catch (e) {
        console.error(e)
    }
}

export const getSubordinates = async (userID) => {
    try {
        return api.get(`users/${userID}/profile/subordinates`)
    } catch (e) {
        console.log(e)
    }
}
